import React, { forwardRef } from 'react';

import { Text } from '@nicheinc/campus-ds';
import { TextProps } from '@nicheinc/campus-ds/atoms';
import { replaceMergeToBraceFormat } from '@global/design-system/atoms/TagsInput';

export type MergeTagsTextContainerProps = {
	mergeTagsText: string;
	children?: React.ReactNode;
	workspaceInfo: any; // TODO: replace with WorkspaceType
} & Partial<TextProps>;

const MergeTagsTextContainer = forwardRef(function MergeTagsTextContainer(
	{ mergeTagsText, workspaceInfo, ...rest }: MergeTagsTextContainerProps,
	ref,
) {
	return (
		<Text ref={ref} {...rest}>
			{replaceMergeToBraceFormat(mergeTagsText, workspaceInfo)}
		</Text>
	);
});

export default MergeTagsTextContainer;
